import React from 'react';
import {Box, Typography, useTheme} from '@mui/material';
import IconAlertDelete from '@components/UI/atoms/icons/IconAlertDelete.svg';
import {ImgIcon, ButtonCancel, StyledModal, Nav, ImgIconClose} from '@components/faqs/StyledFAQ';
import IconCloseModal from '@components/UI/atoms/icons/IconCloseModal.svg';

const WarningUpdateModal = ({isModalOpen, closeModal}) => {
    const theme = useTheme();
    return (
        <StyledModal open={isModalOpen} onClose={closeModal}>
            <Box
                sx={{
                    background: '#FFF',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: '3px',
                    width: '665px',
                    height: '501px',
                    zIndex: '100',
                }}
            >
                <Nav sx={{justifyContent: 'end'}}>
                    <ImgIconClose
                        src={IconCloseModal}
                        onClick={closeModal}
                        sx={{paddingRight: '15px'}}
                    />
                </Nav>
                <Box
                    sx={{
                        display: 'flex',
                        padding: '15px',
                        flexDirection: 'column',
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: theme.typography.fontFamily,
                            fontSize: '24px',
                            fontWeight: 400,
                            marginTop: '30px',
                            alignSelf: 'center',
                        }}
                    >
                        Error al realizar los cambios
                    </Typography>
                    <ImgIcon src={IconAlertDelete} />
                    <Typography
                        sx={{
                            fontFamily: theme.typography.fontFamily,
                            fontSize: '16px',
                            fontWeight: 500,
                            marginTop: '30px',
                            alignSelf: 'center',
                        }}
                    >
                        Ha ocurrido un error, por favor inténtelo de nuevo más tarde.
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        height: '56px',
                        alignItems: 'center',
                        marginTop: '95px',
                        justifyContent: 'flex-end',
                        background: '#EBF0F2',
                    }}
                >
                    <ButtonCancel onClick={closeModal} sx={{marginRight: '30px'}}>
                        CERRAR
                    </ButtonCancel>
                </Box>
            </Box>
        </StyledModal>
    );
};

export default WarningUpdateModal;
